import React, { Fragment, Component } from 'react';
import Container from 'react-bootstrap/Container';
import Jumbotron from 'react-bootstrap/Jumbotron';
import authService from '../../services/AuthService';
import { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';

import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';
import copyIcon from '../../content/copy64.png';
import './Login.css';
import axios from 'axios';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';

/**
 * ConsumerRedirect
 *
 * This component handles the redirect from Cognito after a successful consumer login.
 * Cognito returns the user to this route with tokens in the URL hash fragment.
 *
 * On mount, the component:
 * - Parses the `id_token` and `access_token` from the URL
 * - Calls the Beacon backend API (`account/cadeauthenticate`) to validate the tokens
 * - Displays basic success or error feedback to the user
 *
 * 1. Tokens are displayed in input fields with a copy-to-clipboard icon for convenience.
 * 2. The backend API base URL is defined via the `REACT_APP_BEACON_API` environment variable.
 * 3. The token is ....#id_token=<token>&access_token=<token>&expires_in=3600&token_type=Bearer
 *
 * ⚠️ Note: This version includes a production safeguard warning if accessed from the prod domain.
 */


export class ConsumerRedirect extends Component {

    constructor(props) {
        super(props);

        this.state = {
            idToken: null,
            accessToken: null
        }

        authService.clearAuthenticated();
    }
    componentDidMount = () => {

        // token is ....#id_token=<token>&access_token=<token>&expires_in=3600&token_type=Bearer
        let urlHash = this.props.location.hash;

        let id_token = urlHash.substring(urlHash.indexOf("id") + 9);
        id_token = id_token.substring(0, id_token.indexOf("&"));
        let access_token = urlHash.substring(urlHash.indexOf("access") + 13);
        access_token = access_token.substring(0, access_token.indexOf("&"));

        this.setState({ idToken: id_token, accessToken: access_token });

        // Environment variables
        const beaconApiUri = process.env.REACT_APP_BEACON_API;

        // Check where this is running
        const hostname = window && window.location && window.location.hostname;

        // This codebase is not ready for production
        if (hostname == 'prod.clear-cade.com' || hostname == 'clear-cade.com') {
            apiErrorPopup("CADE AUTISM TEST is not ready for Production");
        }
        
        let accessControl = "*";
        const locApi = axios.create({
            baseURL: beaconApiUri,
            timeout: 8000,
            headers: {
                'Access-Control-Allow-Origin': accessControl,
                'Authorization': 'Bearer ' + id_token
            }
        });

        locApi.post("account/cadeauthenticate", {
            IdToken: id_token,
            AccessToken: access_token
        })
        .then(response => {
            if (response.status == 200) {

                alertPopup("success", "Account Id " + response.data.id + ", username " + response.data.username);
            }
            else {
                let errorMessage = apiResponseHandler(response);
                apiErrorPopup(errorMessage);
            }
        })
        .catch(error => {
            let errorMessage = apiErrorHandler(error);
            apiErrorPopup("CADE AUTISM TEST Error: " + errorMessage);
        });
    }

    copyLink = (elmtId) => {
        /* Get the text field */
        var copyText = document.getElementById(elmtId);

        if (copyText.value.length == 0) {
            alertPopup('error', 'Then press this icon again to copy the link', 'Press "Get Link" First');
            return;
        }

        /* Select the text field */
        copyText.select();

        /* Copy the text inside the text field */
        document.execCommand("copy");

        window.getSelection().removeAllRanges();

        /* Alert the copied text */
        alertPopup('success', "Token copied to the clipboard");
    }

    render() {
        return (

            <Fragment>
                <Jumbotron bsPrefix="jumbotron login_redirect" fluid={false}>
                    <Container>
                        <h1>ID Token</h1>
                        <input id="idToken" value={this.state.idToken} type="text" size={60} placeholder="Id Token" ></input>
                        <span><img style={{ width: 100 }} src={copyIcon} title="Copy to clipboard" alt="Copy to clipboard" onClick={this.copyLink.bind(this, "idToken")} /></span>
                        <p></p>
                        <h1>Access Token</h1>
                        <input id="accessToken" value={this.state.accessToken} type="text" size={60} placeholder="Id Token" ></input>
                        <span><img style={{ width: 100 }} src={copyIcon} title="Copy to clipboard" alt="Copy to clipboard" onClick={this.copyLink.bind(this, "accessToken")} /></span>
                    </Container>
                </Jumbotron>
            </Fragment>
        );
    }
}

export default ConsumerRedirect;




// WEBPACK FOOTER //
// ./src/components/Login/ConsumerRedirect.js